import type { InputHTMLAttributes } from "react";

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "children"> {
  /** Visible label text, rendered beside the box and wired up by the wrapping label. */
  label: string;
}

/**
 * A labelled checkbox on the existing `mmm-inline-toggle` treatment, so a
 * "show completed" style control is declared once rather than re-assembled
 * from a raw input plus a label in each screen that needs one.
 */
export function Checkbox({ label, className = "", ...props }: CheckboxProps) {
  return (
    <label className={`mmm-inline-toggle ${className}`.trim()}>
      <input type="checkbox" className="mmm-input-accent" {...props} />
      {label}
    </label>
  );
}
